import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { IndexPageTemplate } from './landing-page'

export const SPALandingPage = () => {
  const { landingPages } = useStaticQuery(
    graphql`
        query LandingPages {
          landingPages: allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "landing-page"}}}) {
            edges {
                node {
                fields {
                    slug
                }
                id
                frontmatter {
                  heading
                  title
                  main {
                    description
                    heading
                    image1 {
                      alt
                      url
                      title
                      active
                      image {
                        childImageSharp {

                          fluid(maxWidth: 3000, maxHeight: 3000) {
                            ...GatsbyImageSharpFluid
                          }
                        }
                      }
                  }
                  image2 {
                    alt
                    url
                    active
                    title
                    image {
                      childImageSharp {
                        fluid(maxWidth: 3000, maxHeight: 3000) {
                        ...GatsbyImageSharpFluid
                    }
                    }
                    }
                  }
                  image3 {
                    alt
                    url
                    active
                    title
                    image {
                      childImageSharp {
                        fluid(maxWidth: 3000, maxHeight: 3000) {
                        ...GatsbyImageSharpFluid
                    }
                    }
                    }
                  }
                  image4 {
                    alt
                    url
                    active
                    title
                    image {
                      childImageSharp {
                        fluid(maxWidth: 3000, maxHeight: 3000) {
                        ...GatsbyImageSharpFluid
                    }
                    }
                    }
                  }
                  image5 {
                    alt
                    url
                    title
                    active
                    image {
                      childImageSharp {
                        fluid(maxWidth: 3000, maxHeight: 3000) {
                        ...GatsbyImageSharpFluid
                    }
                    }
                    }
                  }
                  }
                  mainpitch {
                    description
                    title
                  }
                  intro {
                    heading
                    description
                    blurbs {
                      text
                    }
                  }
                  description
                  image {
                        childImageSharp {
                          fluid(maxWidth: 400, maxHeight: 400) {
                            ...GatsbyImageSharpFluid
                          }
                        }
                      }
                  }
                }
            }
        }
    }
    `);
  const landingPage = landingPages.edges[0].node;
  return (
    <IndexPageTemplate
      heading={landingPage.frontmatter.heading}
      title={landingPage.frontmatter.title}
      image={landingPage.frontmatter.image}
      main={landingPage.frontmatter.main}
      mainpitch={landingPage.frontmatter.mainpitch}
      description={landingPage.frontmatter.description}
      intro={landingPage.frontmatter.intro}
    />
  )
}
